import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e68d0656"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-10 flex justify-center" }
const _hoisted_2 = { class: "errorMessage mx-auto my-8 w-3/6 text-center" }
const _hoisted_3 = { class: "flex items-stretch main-grid" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "locked flex-col justify-center items-center align-center"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-10" }, "Your NFTs are being staked", -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NFTGrid = _resolveComponent("NFTGrid")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "btnSite nes-btn is-primary mr-5",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stakeAll && _ctx.stakeAll(...args)))
      }, _toDisplayString(_ctx.stakeLabel), 1),
      (_ctx.farmerState === 'staked')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btnSite nes-btn is-primary mr-5",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.startUnstakeAll && _ctx.startUnstakeAll(...args)))
          }, " End Staking "))
        : _createCommentVNode("", true),
      (_ctx.farmerState === 'unstaked' && _ctx.currentVaultNFTs.length)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btnSite nes-btn is-primary mr-5",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.endUnstakeAll && _ctx.endUnstakeAll(...args)))
          }, " NFTs to Wallet "))
        : _createCommentVNode("", true),
      (_ctx.farmerState === 'unstaked' && _ctx.currentVaultNFTs.length)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "btnSite nes-btn is-primary mr-5",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.beginStaking && _ctx.beginStaking(...args)))
          }, " Begin Staking "))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.errorMessage), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_NFTGrid, {
        title: "Not Staked",
        class: "flex-1",
        nfts: _ctx.desiredWalletNFTs,
        onSelected: _ctx.handleWalletSelected
      }, {
        default: _withCtx(() => [
          (_ctx.walletIsLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Loading..."))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["nfts", "onSelected"]),
      (_ctx.bank && _ctx.vault)
        ? (_openBlock(), _createBlock(_component_NFTGrid, {
            key: 0,
            title: "Your Vault",
            class: "flex-1",
            nfts: _ctx.desiredVaultNFTs,
            onSelected: _ctx.handleVaultSelected
          }, {
            default: _withCtx(() => [
              (_ctx.vaultIsLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Loading..."))
                : _createCommentVNode("", true),
              (_ctx.vaultLocked)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["nfts", "onSelected"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}